import * as types from "./types";

export const CompanyInitialState = {
  /// get request of Company
  allCompany: <any>[],
  allCompanyLoading: false,
  allCompanyError: null,

  //get request for single organization
  singleOrganization: null,
  singleOrganizationLoading: false,
  singleOrganizationError: null,
};

export const companyReducer = (state = CompanyInitialState, action: any) => {
  switch (action.type) {
    case types.ALL_COMPANY_GET_FETCH_START:
      return {
        ...state,
        allCompanyLoading: true,
      };
    case types.ALL_COMPANY_GET_FETCH_SUCCESS:
      return {
        ...state,
        allCompany: action.allCompany,
        allCompanyLoading: false,
      };

    case types.ALL_COMPANY_GET_FETCH_FAILURE:
      return {
        ...state,
        allCompanyError: action.allCompanyError,
        allCompanyLoading: false,
      };

    case types.SUPERADMIN_SINGLE_ORGANIZATION_GET_START:
      return {
        ...state,
        singleOrganizationLoading: true,
      };

    case types.SUPERADMIN_SINGLE_ORGANIZATION_GET_SUCCESS:
      // console.log('org',action.singleorg);

      return {
        ...state,
        singleOrganization: action.singleorg,
        singleOrganizationLoading: false,
      };

    case types.SUPERADMIN_SINGLE_ORGANIZATION_GET_FINISH:
      return {
        ...state,
        singleOrganization: action.singleorgError,
        singleOrganizationLoading: false,
      };

    default:
      return state;
  }
};
